<template>
  <div class="text-container">
    <h3>ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</h3>

    <h4>1. Нэр томьёоны тайлбар</h4>
    <ul>
      <li>1.1 “Surgalt Fintax” гэж хэрэглэгч буюу хувь хүн нь <strong>surgalt.fintax.mn</strong> сайтаар бүртгэл үүсгэх, санхүү татварын талаар мэдээлэл, зөвлөгөө болон хувь хүний хөгжилтэй холбоотой бусад сургалт авах зэрэг боломж олгож буй Байгууллагын өмчлөлийн цахим программ хангамжийг;</li>
      <li>1.2 “Surgalt Fintax үйлчилгээ”гэж Хэрэглэгч <strong>surgalt.fintax.mn</strong> -ыг ашиглан санхүү татварын талаар мэдээлэл, зөвлөгөө болон хувь хүний хөгжилтэй холбоотой бусад сургалтыг төлбөртэй болон төлбөргүйгээр авах боломж олгож буйг;</li>
      <li>1.3 “Хэрэглэгч”гэж Surgalt Fintax -д бүртгэл үүсгэн дор дурдсанаар гишүүн хэрэглэгч хувь хүнийг ойлгоно;</li>
      <li>1.3.1 “Гишүүн хэрэглэгч”гэж Surgalt Fintax -д бүртгэл үүсгэн, Surgalt Fintax үйлчилгээг төлбөртэйгөөр авч буй хувь хүнийг;</li>
      <li>1.4 “Байгууллага”гэж энэхүү Surgalt Fintax үйлчилгээг Хэрэглэгчид санал болгож буй “Финтакс Платформ” ХХК-г;</li>
      <li>1.5 “Бүртгэл”гэж хувь хүн энэхүү Үйлчилгээний нөхцөл болон нууцлалын бодлоготой танилцан хүлээн зөвшөөрсний үндсэн дээр өөрийн хувийн мэдээллийг сайн дураар оруулан “Миний бүртгэл” цэс үүсгэн Гишүүн хэрэглэгч болсныг тус тус ойлгоно;</li>
    </ul>

    <h4>2. Ерөнхий зүйл</h4>
    <ul>
      <li>2.1. Аливаа Хэрэглэгч нь Surgalt Fintax -ын санал болгож буй үйлчилгээг ашиглахын өмнө энэхүү Үйлчилгээний нөхцөлийг анхааралтай уншиж танилцсаны үндсэн дээр хүлээн зөвшөөрч “Зөвшөөрөв” товч дарснаар Үйлчилгээний нөхцөл тухайн Хэрэглэгчийн хувьд хүчин төгөлдөр болно.</li>
      <li>2.2. Үйлчилгээний нөхцөлтэй танилцаж зөвшөөрснөөр Хэрэглэгч Surgalt Fintax үйлчилгээтэй холбоотой эрх, үүрэг, хариуцлагыг зөвшөөрсөнд тооцно. Хэрэглэгч Үйлчилгээний нөхцөлийг зөвшөөрөөгүй бол Surgalt Fintax -н санал болгож буй үйлчилгээг авах боломжгүй.</li>
      <li>2.3. Байгууллага нь нэг талын санаачлагаар Үйлчилгээний нөхцөлд нэмэлт, өөрчлөлт оруулах эрхтэй бөгөөд Хэрэглэгч өөрийн бүртгэлийг устгаагүй бол нэмэлт, өөрчлөлтийг зөвшөөрсөнд тооцно.</li>
    </ul>

    <h4>3. Бүртгэл</h4>
    <ul>
      <li>
        3.1. Хэрэглэгч Surgalt Fintax -д өөрийн зөвхөн и-мэйл хаягаараа бүртгэл үүсгэх бөгөөд оруулсан мэдээллийн үнэн зөвийг Гишүүн хэрэглэгч бүрэн хариуцна. Үүнд:
        <ul>
          <li>3.1.1. Хувь хүний овог, нэр;</li>
          <li>3.1.2. И-мэйл хаяг;</li>
          <li>3.1.3. Утасны дугаар;</li>
        </ul>
      </li>
      <li>
        3.2. Хэрэглэгч нь өөрийн бүртгэлийн мэдээллийг чандлан хадгалах үүрэгтэй ба бусдад дамжуулах, бусад байдлаар гуравдагч этгээдэд ашиглах эрхгүй болно. Хэрэв хэрэглэгчийн өөрийн эрсдэлтэй үйлдлээс болж бүртгэлийн мэдээлэл алдагдсан тохиолдолд байгууллага хариуцлага хүлээхгүй бөгөөд энэ талаар хэрэглэгч яаралтай байгууллагад мэдэгдэнэ.
      </li>
    </ul>

    <h4>4. Үйлчилгээ</h4>
    <ul>
      <li>4.1. Surgalt Fintax үйлчилгээг гар утас, зөөьрийн компьютер болон ухаалаг зурагт зэрэг төхөөрөмжүүдээр үзэх боломжтой. Нэгэн зэрэг нэг төхөөрөмжөөр орох боломжтой.</li>
      <li>4.2. Хэрэглэгч нь Surgalt Fintax үйлчилгээний үнэ болон үйлчилгээний нөхцөлтэй сайтар танилцсан байх шаардлагатай ба контент үзэхэд тодорхой төхөөрөмж болон интернет орчин шаардлагатай байж болохыг анхаарна уу.</li>
      <li>4.3. Байгууллага нь Үйлчилгээгээ тогтмол тасралтгүй хүргэхийн төлөө хүчин чармайлт гарган ажиллана. Гэвч гэнэтийн болон давагдашгүй хүчин зүйл (тухайлбал газар хөдлөлт, үер, гал түймэр, хар салхи, халдварт өвчний тархалт болон байгалийн бусад аюулт үзэгдэл, ажил хаялт, төрийн шийдвэр, оролцоо, цахилгаан эрчим хүч тасалдал, нийтийг хамарсан интернетийн доголдол гэх мэт), тоног төхөөрөмжийн өөрчлөлт шинэчлэлт, цахим орчны бусад эрсдэлээс шалтгаалан Үйлчилгээ тасалдаж болох бөгөөд энэ тохиолдолд Байгууллага хариуцлага хүлээхгүй. Хэрэв ямар нэгэн талсалдал гарсан тохиолдолд Байгууллага нь үйлчилгээгээ яаралтай сэргээхэд шаардлагатай бүх арга хэмжээг авч ажиллана.</li>
      <li>4.4. Контентийг үзэх чанар нь Хэрэглэгчийн хэрэглэж буй төхөөрөмж, оршин буй газар, интернет холболтын хурд, тухайн контентийн формат зэрэг олон төрлийн хүчин зүйлээс шалтгаалан өөр өөр байж болохыг анхаарна уу.</li>
    </ul>

    <h4>5. Төлбөр төлөх журам</h4>
    <ul>
      <li>5.1. Нэгж хичээлийг худалдан авч үзэх. Энэ тохиолдолд төлбөрийг QPAY ашиглан нэг удаа, үйлчилгээ авахаас өмнө хийсэн байна. Нэгж хичээл нь 3 сарын турш Хэрэглэгчид идэвхтэй харагдана.</li>
      <li>5.2. 5.1 дээр заасан төлбөрүүдийг буцаан олгох боломжгүй.</li>
      <li>5.3. Байгууллага нь QPAY төлбөрийн хэрэгслийг санал болгох ба тухайн улс, банкны хураамж зэргээс хамааран төлөх үнэ нь өөр өөр байж болох ба үүнтэй холбогдуулан нэмэлт хураамж бодогдож болохыг анхаарна уу. Хэрэглэгч нь төлбөр төлөхөд явцад алдаатай гүйлгээ хийснээс бий болсон үр дагаварыг Байгууллага хариуцахгүй.</li>
      <li>5.4. Үнэ төлөгдсөний дараа тухайн Үйлчилгээний эрх нээгдэх ба үнэ нэгэнт төлөгдсөн бол илүү төлснөөс бусад тохиолдолд буцаан олгохгүй. Илүү төлсөн төлбөрийг буцаан авах хүсэлтээ холбогдох мэдээлэл, нотлох баримтын хамт Байгууллагын info@taxacc.mn-д илгээх бөгөөд Байгууллага хянаж, үндэслэлтэй гэж үзвэл ажлын 5 хоногийн дотор буцаалт хийнэ.</li>
    </ul>

    <h4>6. Хэрэглэгчийн гомдол, санал хүсэлт хүлээн авах, шийдвэрлэх</h4>
    <ul>
      <li>6.1. Хэрэглэгч Байгууллагын цахим хуудас info@taxacc.mn болон холбоо барих утас 7505 3555 сувгуудаар дамжуулан Байгууллагад гомдол, хүсэлт гаргах эрхтэй.</li>
      <li>6.2. Хэрэглэгчээс ирүүлсэн гомдол, хүсэлтийг Байгууллага хүлээн авснаас хойш ажлын 10 өдрийн дотор шийдвэрлэнэ. Гомдол, хүсэлтийг шийдвэрлэхэд энд зааснаас урт хугацаа шаардлагатай бол Байгууллага нь хариу өгөх хугацааг Хэрэглэгчид мэдэгдэнэ.</li>
      <li>6.3. Хэрэглэгчийн гомдол, хүсэлтийг шийдвэрлэх явцад Байгууллагаас шаардсан мэдээллийг Хэрэглэгч бүрэн, үнэн зөвөөр гаргаж өгөх үүрэгтэй.</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Content is structured directly within the template using HTML lists
    };
  }
};
</script>

<style scoped>
.text-container {
  margin: 20px auto;
  max-width: 800px;
  padding: 20px;
  font-family: sans-serif;
}
h1 {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
}
h4 {
  font-size: 22px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}
ul {
  margin-left: 20px;
  margin-bottom: 1em;
}
li {
  line-height: 1.6;
  margin-bottom: 0.5em;
}
</style>
